import styles from './mark-as-favorite-control.module.scss';
import globalStyles from "../../../global-styles.module.scss"
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import { Tooltip } from '@mui/material';
import { useTranslation } from "../../../i18n/useTranslation";
import StarIcon from '@mui/icons-material/Star';
import classNames from 'classnames';
import { updateFavoriteProduct, addFavoriteProductMessageError } from '../favorite-products.service';
import { HttpStatusCode } from 'axios';
import { Utils } from '../../../shared/constants/utilities.constants';
import { toast } from 'react-toastify';
import { useState } from 'react';

export interface IMarkAsFavoriteControlInput {
    isActiveInit: boolean;
    variantProductUuid: string;
    parentProductUuid?: string;
    categoryUuid?: string;
}

const MarkAsFavoriteControl: React.FC<IMarkAsFavoriteControlInput> = ({categoryUuid, parentProductUuid, variantProductUuid, isActiveInit}) => {
    const { t } = useTranslation('translation');
    const showError = (message: string) => toast.error(message);
    const [isActive, setIsActive] = useState<boolean>(isActiveInit);

    const handleResponse = () => {
        setIsActive(isActiveInit);
        showError(t(addFavoriteProductMessageError));   
    }

    const handleUpdateFavoriteProduct = (isActive: boolean) => {
        if (!Utils.isNullOrUndefined(categoryUuid) && !Utils.isNullOrUndefined(parentProductUuid)) {
            updateFavoriteProduct(categoryUuid as string, parentProductUuid as string, variantProductUuid, isActive).then((response: any) => {
                if (!(response && response.status === HttpStatusCode.Ok && !Utils.isNullOrUndefined(response.data))) {
                    handleResponse();
                }
            }).catch(() => handleResponse());
        } else {
            handleResponse();
        }
    }

    return (
        <div className={styles.content}>
            <Tooltip title={t('MARK_AS_FAVORITE')}>
                <button 
                    className={globalStyles.default_button_style} 
                    onClick={() => {
                        setIsActive(!isActive);
                        handleUpdateFavoriteProduct(!isActive);
                    }}>
                    {isActive && <StarIcon className={classNames(styles.icon, styles.active)}></StarIcon>}
                    {!isActive && <StarOutlineIcon className={classNames(styles.icon, styles.deactivate)}></StarOutlineIcon>}
                </button>
           </Tooltip>
        </div>
    )
}

export default MarkAsFavoriteControl;